module.exports = __webpack_public_path__ + "static/img/size_view.94538e80.jpg";